import { STYLE } from '@wix/component-protocol/schema';

const COMBINED_PADDING_CSS_PROPERTY_TYPES = [STYLE.CSS_PROPERTY_TYPE.padding];

export const PADDING_CSS_PROPERTY_TYPES = [
  ...COMBINED_PADDING_CSS_PROPERTY_TYPES,
  STYLE.CSS_PROPERTY_TYPE.paddingTop,
  STYLE.CSS_PROPERTY_TYPE.paddingRight,
  STYLE.CSS_PROPERTY_TYPE.paddingBottom,
  STYLE.CSS_PROPERTY_TYPE.paddingLeft,
  STYLE.CSS_PROPERTY_TYPE.paddingInlineStart,
  STYLE.CSS_PROPERTY_TYPE.paddingInlineEnd,
];

const COMBINED_GAP_CSS_PROPERTY_TYPES = [STYLE.CSS_PROPERTY_TYPE.gap];

export const GAP_CSS_PROPERTY_TYPES = [
  ...COMBINED_GAP_CSS_PROPERTY_TYPES,
  STYLE.CSS_PROPERTY_TYPE.rowGap,
  STYLE.CSS_PROPERTY_TYPE.columnGap,
];
